import {
  createInvalidLazyModuleError,
  getNeverSettlingPromise,
  isStaleBuildError,
  recoverFromStaleBuild,
} from './staleBuildGuard';

export async function loadLazyModule(
  loader,
  {
    moduleId = 'unknown-module',
    recoverFromStaleBuildImpl = recoverFromStaleBuild,
  } = {},
) {
  try {
    const resolvedModule = await loader();

    if (!resolvedModule || typeof resolvedModule.default === 'undefined') {
      const invalidModuleError = createInvalidLazyModuleError(moduleId, resolvedModule);
      const recoveryResult = await recoverFromStaleBuildImpl({
        reason: `invalid-lazy-module:${moduleId}`,
      });

      if (recoveryResult?.didTriggerRefresh) {
        return getNeverSettlingPromise();
      }

      invalidModuleError.recoveryAttempted = true;
      throw invalidModuleError;
    }

    return resolvedModule;
  } catch (error) {
    if (isStaleBuildError(error) && !error?.recoveryAttempted) {
      const recoveryResult = await recoverFromStaleBuildImpl({
        reason: `lazy-load:${moduleId}`,
      });

      if (recoveryResult?.didTriggerRefresh) {
        return getNeverSettlingPromise();
      }
    }

    throw error;
  }
}
